<form
  *ngIf="initialized && bookmarkCategoryStore.asArray() as categories"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper
      [label]="'Name'"
      [name]="'title'"
      [formField]="form.get('title')">
      <input
        pInputText
        id="title"
        type="text"
        formControlName="title"
        class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper [label]="'Überschrift'" [name]="'headline'">
      <input
        pInputText
        id="headline"
        type="text"
        formControlName="headline"
        class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper label="Themenbereiche" name="parent">
      <p-multiSelect
        id="bookmarkCategories"
        formControlName="bookmarkCategories"
        [showClear]="true"
        [filter]="categories.length > 10"
        [filterFields]="['title']"
        [options]="categories"
        optionLabel="title"
        optionValue="_id"
        dataKey="_id"
        display="chip">
        <ng-template pTemplate="header">
          <div class="p-2 border-bottom-1 surface-border">
            <p-button
              styleClass="w-auto"
              [text]="true"
              [rounded]="true"
              (onClick)="openBookmarkCategoryForm()"
              icon="fas fa-plus"
              label="hinzufügen"></p-button>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <div class="flex align-items-center gap-2">
            <i class="fas fa-layer-group"></i>
            <div>{{ item.title }}</div>
          </div>
        </ng-template>
      </p-multiSelect>
    </app-form-field-wrapper>

    <app-tag-dropdown formControlName="tags" mode="all"></app-tag-dropdown>

    <app-form-field-wrapper
      [colSize]="6"
      [label]="'öffentlich sichtbar'"
      [name]="'published'">
      <p-inputSwitch id="published" formControlName="published"></p-inputSwitch>
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [colSize]="6"
      [label]="'Jahresnavigation ausblenden'"
      name="disableControls">
      <p-inputSwitch
        id="disableControls"
        formControlName="disableControls"></p-inputSwitch>
    </app-form-field-wrapper>
    @if (
      !itemToEdit ||
      (itemToEdit &&
        this.activeUserStore.user() &&
        itemToEdit.user === this.activeUserStore.user()?._id)
    ) {
      <app-form-field-wrapper
        [colSize]="6"
        [label]="'privat'"
        [name]="'private'">
        <p-inputSwitch id="private" formControlName="private"></p-inputSwitch>
      </app-form-field-wrapper>
    }
    <!--
    <app-form-field-wrapper
      [colSize]="6"
      label="als Vorlage speichern"
      name="useAsTemplate"
      [floatingLabel]="false">
      <p-inputSwitch
        id="useAsTemplate"
        formControlName="useAsTemplate"></p-inputSwitch>
    </app-form-field-wrapper>-->

    <app-alert
      header="Fehlende Konfiguration"
      class="px-2 w-full"
      [canToggle]="false"
      *ngIf="itemToEdit && !itemToEdit.config">
      <p class="m-0">Die Ansicht hat noch keine Konfiguration</p>
      <p>
        <a href="#">Jetzt konfigurieren <i class="fas fa-arrow-right"></i></a>
      </p>
    </app-alert>
  </div>

  <p-divider></p-divider>

  <!-- Guest Link Section -->
  <div formGroupName="guestLink" class="mb-3">
    <p-panel [toggleable]="true">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-3">
          <i class="fas fa-link text-xl"></i>
          <div>
            <div class="font-semibold">Gast-Zugriff</div>
            <div class="text-sm text-600">
              Teilen Sie diese Ansicht mit einem öffentlichen Link
            </div>
          </div>
        </div>
      </ng-template>

      <div class="grid">
        <app-form-field-wrapper
          [colSize]="4"
          [floatingLabel]="false"
          [label]="'Gast-Link aktivieren'"
          [name]="'guestLinkEnabled'">
          <p-inputSwitch
            id="guestLinkEnabled"
            formControlName="enabled"></p-inputSwitch>
        </app-form-field-wrapper>

        @if (form.get('guestLink.enabled')?.value) {
          <p-button
            class="ml-auto mt-2"
            size="small"
            rounded="true"
            severity="danger"
            icon="fas fa-trash"
            label="Gast-Link löschen"
            (click)="deleteGuestLink()"></p-button>
        }

        @if (form.get('guestLink.enabled')?.value) {
          <div class="col-12">
            <label class="block mb-2">Link</label>
            <div class="p-inputgroup">
              <input
                type="text"
                pInputText
                [value]="getGuestLinkUrl()"
                readonly
                class="font-mono text-sm" />
              <button
                pButton
                type="button"
                icon="fas fa-copy"
                class="p-button-secondary"
                (click)="copyGuestLink()"
                pTooltip="Link kopieren"
                tooltipPosition="top"></button>
              <button
                pButton
                type="button"
                icon="fas fa-external-link-alt"
                class="p-button-secondary"
                (click)="openGuestLink()"
                pTooltip="Link öffnen"
                tooltipPosition="top"></button>
            </div>
            <small class="text-color-secondary block mt-1">
              <i class="fas fa-info-circle"></i>
              Personen mit diesem Link können die Ansicht sehen, auch wenn sie
              nicht angemeldet sind
            </small>
          </div>

          <app-form-field-wrapper
            [colSize]="12"
            [label]="'PIN (optional)'"
            [floatingLabel]="false"
            [name]="'expiresAt'">
            <div class="flex gap-3">
              <p-inputOtp formControlName="password" [mask]="pwMasked" />
              <p-button
                [outlined]="true"
                (click)="pwMasked = !pwMasked"
                [icon]="
                  pwMasked ? 'fas fa-eye' : 'fas fa-eye-slash'
                "></p-button>
              <p-button
                [outlined]="true"
                (click)="copyPassword()"
                icon="fas fa-copy"></p-button>
            </div>
          </app-form-field-wrapper>

          <app-form-field-wrapper
            [colSize]="12"
            [warning]="
              form.get('guestLink.expiresAt')?.value &&
              isExpired(form.get('guestLink.expiresAt')?.value || '')
                ? 'Der Link ist abgelaufen'
                : undefined
            "
            [label]="'Ablaufdatum (optional)'"
            help="Lassen Sie dieses Feld leer, wenn der Link unbegrenzt gültig sein
              soll"
            [name]="'expiresAt'">
            <p-calendar
              id="expiresAt"
              formControlName="expiresAt"
              [showTime]="true"
              [showIcon]="true"
              [showButtonBar]="true"
              dateFormat="dd.mm.yy"
              placeholder="Kein Ablaufdatum"
              appendTo="body"></p-calendar>
          </app-form-field-wrapper>
        }
      </div>

      @if (form.get('guestLink.enabled')?.value) {
        <ng-template pTemplate="footer">
          <div
            class="flex flex-wrap gap-2"
            *ngIf="form.get('guestLink.createdAt')?.value">
            <div
              class="surface-ground px-3 pt-3 pb-3 border-round text-sm text-color-secondary">
              <i class="fas fa-info-circle mr-2"></i>
              Link erstellt am:
              {{
                form.get('guestLink.createdAt')?.value
                  | date: 'dd.MM.yyyy HH:mm'
              }}
              Uhr
            </div>

            <!-- Regenerate Token Button -->

            <p-button
              label="Link aktualisieren"
              icon="fas fa-sync-alt"
              severity="warning"
              [outlined]="true"
              [rounded]="true"
              (onClick)="generateGuestToken()"
              pTooltip="Achtung: Der alte Link wird ungültig"
              tooltipPosition="top"></p-button>
          </div>
        </ng-template>
      }
    </p-panel>
  </div>

  <p-divider></p-divider>

  <app-form-footer
    [cancelLevel]="atlasForm ? 0 : 1"
    [showRemoveButton]="
      !!(
        itemToEdit &&
        itemToEdit._id &&
        bookmarkCategoryHelper.getCategoriesForBookmark(itemToEdit._id)
          .length &&
        permissionService.checkBookmarkRights(
          bookmarkCategoryHelper.getCategoriesForBookmark(itemToEdit._id),
          'remove'
        )
      )
    "
    [isEditMode]="!!itemToEdit?._id"
    (cancel)="cancel.emit()"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.title) : undefined
    "></app-form-footer>
</form>
